import React from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import withStyles from '@mui/styles/withStyles';
import { I18n } from 'i18n-js';
import ActionButton from '../common/ActionButton';
import translations from '../../locales.json';

const i18n = new I18n(translations);

const styles = theme => ({
  centerContent: {
    display: 'flex',
    justifyContent: 'center',
    justifyItems: 'center',
  },
  videoWrapper: {
    position: 'relative',
    paddingTop: '56.25%',
  },
  videoPlayer: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  videoGrid: {
    margin: 'auto',
    '@media (min-width: 600px) and (max-width: 1024px) and (min-height: 1024px)': {
      maxWidth: '100%',
      flexBasis: '100%',
      marginBottom: theme.spacing(2),
    },
  },
  thankYouText: {
    '@media (min-width: 600px) and (max-width: 1024px) and (min-height: 1024px)': {
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
    '@media (min-width: 1300px)': {
      marginBottom: theme.spacing(1),
    },
  },
});

const OrganizationApproval = ({ classes }) => {
  const openCalendly = (e) => {
    if (window.Calendly) {
      e.preventDefault();
      let url = e.currentTarget.href;
      if (window.intercomSettings) {
        const { name, email } = window.intercomSettings;
        url = [url, '?name=', name, '&&email=', email].join('');
      }
      window.Calendly.showPopupWidget(url);
    }
  };

  return (
    <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={2}>
      <Grid item xs={12}>
        <Typography
          component="h1"
          variant="subtitle2"
          align="center"
          className={classes.thankYouText}
        >
          {i18n.t('js.sign_up.organization.approval.thank_you_text')}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={10} className={classes.videoGrid}>
        <div className={classes.videoWrapper}>
          <ReactPlayer
            url="https://www.youtube.com/embed/R8vo1RTu9HU"
            className={classes.videoPlayer}
            width="100%"
            height="100%"
          />
        </div>
      </Grid>
      <Grid item xs={12} className={classes.centerContent}>
        <ActionButton
          text={i18n.t('js.sign_up.organization.approval.request_demo')}
          href="https://calendly.com/zac-rakuna"
          target="_blank"
          onClick={openCalendly}
          style={{ marginTop: 8, maxWidth: 200 }}
        />
      </Grid>
    </Grid>
  );
};

OrganizationApproval.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(OrganizationApproval);
